import { apiCall } from "./service";
import { BASE_URL } from "./URL";

export const milestoneApi = {
  getMilestones(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url;
    
    switch (parent) {
     
      case "Portfolio":
        url = `${BASE_URL}Portfolios/${id}/milestones`;
        break;
        
      case "Program":
        url = `${BASE_URL}Programs/${id}/milestones`;
        break;

      case "Project":
        url = `${BASE_URL}Projects/${id}/milestones`;
        break;
        
      default:
        url = ``; //set to empty to prevent fetch all records but still throw error
    }
  
    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;
  
    return apiCall.pagination({ url: fullUrl });
  },

  getMilestone(id) {
    return apiCall.get({url: `${BASE_URL}milestones/${id}`});
  },

  createMilestone(payload) {
    return apiCall.post({
      url: `${BASE_URL}milestones`,
      params: payload,
    });
  },

  updateMilestone(payload) {
    return apiCall.put({
      url: `${BASE_URL}milestones/${payload.id}`,
      params: payload.data,
    });
  },

  updateMilestoneFlag(payload) {
    return apiCall.patch({
          url: `${BASE_URL}milestones/${payload.id}`,
          params: payload.data,
        });
  },

  deleteMilestone(id) {
    return apiCall.delete({
      url: `${BASE_URL}milestones/${id}`,
    });
  },
};

export default milestoneApi;
